import _isDarkMode, { subscribeToColorScheme } from "is-dark";
import css from './dark-mode-exports.scss';
import mitt from 'mitt';
import UA from './ua';
import { frdVersion } from './version';
var DarkModeService = /** @class */ (function () {
    function DarkModeService() {
        var _this = this;
        this.isDarkMode = false;
        /** 是否启用自动监听黑暗模式变化 */
        this.isWatchEnabled = true;
        this.event = mitt();
        if (UA.isIOS() && frdVersion.since('6.22')) {
            // iOS 需要自动监听 dark-mode 变化
            this.isDarkMode = _isDarkMode();
            subscribeToColorScheme(function (state) {
                if (_this.isWatchEnabled) {
                    _this.isDarkMode = state === 'dark';
                    _this.emit();
                }
            });
        }
        else if (UA.isAndroid() && frdVersion.since('6.26')) {
            // 安卓切换时会自动销毁所有webview, 因此不需要监听
            this.isDarkMode = decodeURIComponent(location.search).indexOf('dark_mode=1') >= 0;
        }
        this.updateCss();
        this.on(function () { return _this.updateCss(); });
    }
    DarkModeService.prototype.disableWatch = function () {
        this.isWatchEnabled = false;
    };
    DarkModeService.prototype.enableWatch = function () {
        this.isWatchEnabled = true;
    };
    DarkModeService.prototype.enable = function () {
        this.isDarkMode = true;
        document.documentElement.removeAttribute('disable-dark');
        this.emit();
    };
    DarkModeService.prototype.disable = function () {
        this.isDarkMode = false;
        document.documentElement.setAttribute('disable-dark', '1');
        this.emit();
    };
    DarkModeService.prototype.emit = function () {
        this.event.emit('change', this.isDarkMode);
    };
    DarkModeService.prototype.on = function (cb) {
        this.event.on('change', cb);
    };
    DarkModeService.prototype.off = function (cb) {
        this.event.off('change', cb);
    };
    DarkModeService.prototype.updateCss = function () {
        if (this.isDarkMode && UA.isDoubanApp()) {
            document.documentElement.setAttribute('dark-mode', '1');
        }
        else {
            document.documentElement.removeAttribute('dark-mode');
        }
    };
    return DarkModeService;
}());
export var DarkMode = new DarkModeService();
export var isDarkMode = function () {
    return DarkMode.isDarkMode;
};
if (process.env.NODE_ENV === 'development') {
    window['DarkMode'] = DarkMode;
}
if (process.env.DARK === 'true') {
    DarkMode.enable();
}
// ### 为了避免 iOS 打开 rexxar 页时白屏闪一下，还有非 App 下可能出现黑暗模式，需要在页面内联 js 中注入一段代码:
if (/com\.douban\.frodo/.test(navigator.userAgent.toLowerCase())) {
    document.documentElement.setAttribute('data-isapp', '1');
}
export var DarkColors = {
    green110: css.green110,
    green110_dark: css.green110_dark,
    green100: css.green100,
    green100_dark: css.green100_dark,
    green70: css.green70,
    green70_alpha: css.green70_alpha,
    green70_dark: css.green70_dark,
    green70_dark_alpha: css.green70_dark_alpha,
    green40: css.green40,
    green40_alpha: css.green40_alpha,
    green40_dark: css.green40_dark,
    green40_dark_alpha: css.green40_dark_alpha,
    green10: css.green10,
    green10_alpha: css.green10_alpha,
    green10_dark: css.green10_dark,
    green10_dark_alpha: css.green10_dark_alpha,
    black100: css.black100,
    black100_alpha: css.black100_alpha,
    black100_dark: css.black100_dark,
    black100_dark_alpha: css.black100_dark_alpha,
    black90: css.black90,
    black90_alpha: css.black90_alpha,
    black90_dark: css.black90_dark,
    black90_dark_alpha: css.black90_dark_alpha,
    black50: css.black50,
    black50_alpha: css.black50_alpha,
    black50_dark: css.black50_dark,
    black50_dark_alpha: css.black50_dark_alpha,
    black25: css.black25,
    black25_alpha: css.black25_alpha,
    black25_dark: css.black25_dark,
    black25_dark_alpha: css.black25_dark_alpha,
    black12: css.black12,
    black12_alpha: css.black12_alpha,
    black12_dark: css.black12_dark,
    black12_dark_alpha: css.black12_dark_alpha,
    black8: css.black8,
    black8_alpha: css.black8_alpha,
    black8_dark: css.black8_dark,
    black8_dark_alpha: css.black8_dark_alpha,
    black3: css.black3,
    black3_alpha: css.black3_alpha,
    black3_dark: css.black3_dark,
    black3_dark_alpha: css.black3_dark_alpha,
    black0: css.black0,
    black0_alpha: css.black0_alpha,
    black0_dark: css.black0_dark,
    black0_dark_alpha: css.black0_dark_alpha,
    black_empty: css.black_empty,
    black_empty_dark: css.black_empty_dark,
    black80: css.black80,
    black80_alpha: css.black80_alpha,
    black80_dark: css.black80_dark,
    black80_dark_alpha: css.black80_dark_alpha,
    black70: css.black70,
    black70_alpha: css.black70_alpha,
    black70_dark: css.black70_dark,
    black70_dark_alpha: css.black70_dark_alpha,
    black0_button: css.black0_button,
    black0_button_alpha: css.black0_button_alpha,
    black0_button_dark: css.black0_button_dark,
    blue100: css.blue100,
    blue100_dark: css.blue100_dark,
    blue110: css.blue110,
    blue110_dark: css.blue110_dark,
    blue70: css.blue70,
    blue70_alpha: css.blue70_alpha,
    blue70_dark: css.blue70_dark,
    blue70_dark_alpha: css.blue70_dark_alpha,
    blue40: css.blue40,
    blue40_alpha: css.blue40_alpha,
    blue40_dark: css.blue40_dark,
    blue40_dark_alpha: css.blue40_dark_alpha,
    blue10: css.blue10,
    blue10_alpha: css.blue10_alpha,
    blue10_dark: css.blue10_dark,
    blue10_dark_alpha: css.blue10_dark_alpha,
    orange100: css.orange100,
    orange100_dark: css.orange100_dark,
    orange110: css.orange110,
    orange110_dark: css.orange110_dark,
    orange70: css.orange70,
    orange70_alpha: css.orange70_alpha,
    orange70_dark: css.orange70_dark,
    orange70_dark_alpha: css.orange70_dark_alpha,
    orange40: css.orange40,
    orange40_alpha: css.orange40_alpha,
    orange40_dark: css.orange40_dark,
    orange40_dark_alpha: css.orange40_dark_alpha,
    orange10: css.orange10,
    orange10_alpha: css.orange10_alpha,
    orange10_dark: css.orange10_dark,
    orange10_dark_alpha: css.orange10_dark_alpha,
    apricot100: css.apricot100,
    apricot100_dark: css.apricot100_dark,
    apricot110: css.apricot110,
    apricot110_dark: css.apricot110_dark,
    apricot70: css.apricot70,
    apricot70_alpha: css.apricot70_alpha,
    apricot70_dark: css.apricot70_dark,
    apricot70_dark_alpha: css.apricot70_dark_alpha,
    apricot40: css.apricot40,
    apricot40_alpha: css.apricot40_alpha,
    apricot40_dark: css.apricot40_dark,
    apricot40_dark_alpha: css.apricot40_dark_alpha,
    apricot10: css.apricot10,
    apricot10_alpha: css.apricot10_alpha,
    apricot10_dark: css.apricot10_dark,
    apricot10_dark_alpha: css.apricot10_dark_alpha,
    red110: css.red110,
    red110_dark: css.red110_dark,
    red100: css.red100,
    red100_dark: css.red100_dark,
    red70: css.red70,
    red70_alpha: css.red70_alpha,
    red70_dark: css.red70_dark,
    red70_dark_alpha: css.red70_dark_alpha,
    red40: css.red40,
    red40_alpha: css.red40_alpha,
    red40_dark: css.red40_dark,
    red40_dark_alpha: css.red40_dark_alpha,
    red10: css.red10,
    red10_alpha: css.red10_alpha,
    red10_dark: css.red10_dark,
    red10_dark_alpha: css.red10_dark_alpha,
    white100: css.white100,
    white70: css.white70,
    white50: css.white50,
    white30: css.white30,
    white10: css.white10,
};
var darkModeMap = {};
// 由于重复色值比较多，做个反转让常用的优先匹配，开发时最好多测试一下，如果有问题，就用第二个参数。
for (var _i = 0, _a = Object.keys(DarkColors).reverse(); _i < _a.length; _i++) {
    var key = _a[_i];
    if (key.indexOf('_dark') < 0) {
        darkModeMap[css[key]] = css["".concat(key.replace('_alpha', ''), "_dark")];
    }
}
/**
 * 由于重复色值比较多最好尽量用第二个参数
 * @param color
 * @param darkColor
 */
export function getAutoColor(color, darkColor) {
    if (darkColor === void 0) { darkColor = darkModeMap[color] || color; }
    if (!isDarkMode()) {
        return color;
    }
    return darkColor;
}
//# sourceMappingURL=dark-mode.js.map